import { render, staticRenderFns } from "./BrowseElevatorGaiyo.vue?vue&type=template&id=866547fc&scoped=true&"
import script from "./BrowseElevatorGaiyo.vue?vue&type=script&lang=js&"
export * from "./BrowseElevatorGaiyo.vue?vue&type=script&lang=js&"
import style0 from "./BrowseElevatorGaiyo.vue?vue&type=style&index=0&id=866547fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866547fc",
  null
  
)

export default component.exports